<template>
	<div class="modal fade" id="modalUsuarioRoles" role="dialog" aria-labelledby="modal-cliente-label" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
		        	<h5 class="modal-title" id="modal-cliente-label">
		        		<i class="material-icons">vpn_key</i>
		        		Roles y permisos
		        	</h5>
		        	<div class="btn-group">
				        <button type="button" class="btn btn-link btn-sm" v-on:click="update()">
				        	<i class="material-icons">refresh</i>
				        </button>
			        	<button type="button" class="btn btn-link btn-sm" data-dismiss="modal" aria-label="Close">
				        	<i class="material-icons">close</i>
				        </button>
		        	</div>
		    	</div>
		    	<preloader v-if="loading"></preloader>
		    	<div class="modal-body p-0">
		    		<ul class="nav nav-tabs" id="permisosRoles" role="tablist">
						<li class="nav-item">
					    	<a class="nav-link active" id="roles-tab" data-toggle="tab" href="#roles" role="tab" aria-controls="roles" aria-selected="true">Roles</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="permisos-tab" data-toggle="tab" href="#permisos" role="tab" aria-controls="permisos" aria-selected="false">Permisos</a>
						</li>
					</ul>
					<div class="tab-content" id="permisosRolesContent">
						<div class="tab-pane fade show active" id="roles" role="tabpanel" aria-labelledby="roles-tab">
							<ul class="list-group">
								<li class="list-group-item" v-for="(rol, index) in roles">
									<div class="custom-control custom-checkbox">
										<input type="checkbox" class="custom-control-input" :id="'roles'+index" v-model="rolesUser" :value="rol.CODIGO">
										<label class="custom-control-label" :for="'roles'+index">{{rol.NOMBRE}}</label>
									</div>
								</li>
							</ul>
						</div>
						<div class="tab-pane fade px-3" id="permisos" role="tabpanel" aria-labelledby="permisos-tab">
							<ul class="list-unstyled">
							 	<li v-for="(parent, index) in permisos">
							 		{{index | capitalize}}
							 		<ul class="list-unstyled pl-3">
										<li v-for="(modulo, index) in parent">
											<strong ref="treeModules">
												{{index | capitalize}}
											</strong>

											<ul class="list-group mb-2 pl-5">
												<li v-for="(permiso, index) in modulo" class="list-group-item">
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" :id="'permiso'+index" v-model="permisosUser" :value="permiso.CODIGO">
														<label class="custom-control-label" :for="'permiso'+index">{{permiso.NOMBRE}}</label>
													</div>
												</li>
											</ul>
										</li>
							 		</ul>
								</li>
							</ul>
						</div>
					</div>
		    	</div>

		    	<div class="modal-footer">
		    		<button class="btn btn-success" v-on:click="saveRolesPermisos()">
		    			<i class="material-icons">save</i>
		    			Guardar roles y permisos
		    		</button>
		    	</div>
		    </div>
		</div>
	</div>
</template>
<script>
	export default {
		mounted(){
        	this.getRoles();
        	this.getPermisos();
        	this.modal()
		},

		data(){
			return {
				loading: false,
				usuario: '',

				permisos: [],
				roles: [],

				rolesUser: [],
				permisosUser: []
			}
		},

		methods: {
			getRoles: function(){
				this.loading = true;
				var url = 'api/roles';

				axios.get(url)
				.then(response => {
					this.roles = response.data
				}).catch(error => {
					//
				}).then(()=>{
					this.loading = false;
				});
			},

			getRolesUser: function(){
				this.loading = true;
				var url = 'api/roles/'+this.usuario;

				axios.get(url)
				.then(response => {
					this.rolesUser = response.data
				}).catch(error => {
					//
				}).then(()=>{
					this.loading = false;
				});
			},

			getPermisos: function(){
				this.loading = true;
				var url = 'api/permisos';

				axios.get(url)
				.then(response => {
					this.permisos = response.data
				}).catch(error => {
					//
				}).then(()=>{
					this.loading = false;
				});
			},

			getPermisosUser: function(){
				this.loading = true;
				var url = 'api/permisos/'+this.usuario;

				axios.get(url)
				.then(response => {
					this.permisosUser = response.data
				}).catch(error => {
					//
				}).then(()=>{
					this.loading = false;
				});
			},

			modal: function(){
				var $module = this
				$(this.$el).on('show.bs.modal', function (event) {
					var button = $(event.relatedTarget)
					$module.usuario = button.data('usuario')
					$module.getRolesUser()
					$module.getPermisosUser()

					$module.$nextTick(() => {
						var permisos = $module.$refs['treeModules']
						for (var i = 0; i <= permisos.length - 1; i++) {
							permisos[i].addEventListener('click', function(){
								console.log(this.nextElementSibling.nextElementSibling)
								if (this.nextElementSibling.classList) {
									this.nextElementSibling.classList.toggle("d-none")
								}else {
									// For IE9
									var classes = this.nextElementSibling.className.split(" ");
									var i = classes.indexOf("d-none");

									if (i >= 0)
									classes.splice(i, 1);
									else
									classes.push("d-none");
									element.className = classes.join(" "); 
								}
							});
						}
					})
				})
			},

			update: function(){
				this.getRoles()
				this.getPermisos()

				this.getRolesUser()
				this.getPermisosUser()
			},

			saveRolesPermisos: function(){
				this.loading = true;
				var url = 'api/permisos/'+this.usuario+'/store';

				axios.post(url, {
					permisos: this.permisosUser,
					roles: this.rolesUser
				})
				.then(response => {
					this.$toasted.show('Los roles y permisos han sido asignados.');
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loading = false;
				});
			}
		},

		filters: {
			capitalize: function (value) {
				if (!value) return ''
				value = value.toString().replace('.', ' ')
				return value.charAt(0).toUpperCase() + value.slice(1)
			}
		}
	}
</script>